import type { ListField } from "./types";

export type ListRow = { id: number; values: Record<string, string> };

export const listRowKey = (prefix: string, id: number, column: string) =>
  `${prefix}.${id}.${column}`;

// A fetchable, single non-secret column with no pinned row is an "acquire a
// set" allowlist (the models list), which renders as a picker; anything else is
// editable key/value pairs.
export const isAllowlistListField = (item: ListField) =>
  !!item.fetch &&
  item.columns.length === 1 &&
  !item.columns[0]!.secret &&
  !item.primaryRow;

// Sentinel configuration keys the fetch-from-provider flow writes so the UI
// can react to async completion (empty when idle/done, "fetching", or "error").
// Row ids are numeric, so these never collide with row keys.
export const listFetchStateKey = (prefix: string) => `${prefix}.fetchState`;
export const listFetchErrorKey = (prefix: string) => `${prefix}.fetchError`;

export function listRows(
  configuration: Record<string, string>,
  prefix: string
): ListRow[] {
  const pattern = new RegExp(`^${prefix}\\.(\\d+)\\.(\\w+)$`);
  const rows = new Map<number, Record<string, string>>();
  for (const [key, value] of Object.entries(configuration)) {
    const match = key.match(pattern);
    if (!match) continue;
    const id = Number(match[1]);
    const row = rows.get(id) ?? {};
    row[match[2]!] = value;
    rows.set(id, row);
  }
  return [...rows.entries()]
    .sort(([a], [b]) => a - b)
    .map(([id, values]) => ({ id, values }));
}
